import React from 'react';
import ProductInterface from '../ProductInterface';
import WindroseOptions from './WindroseOptions';
import { processWindrose } from './windroseProcess';

export default function Windrose() {
  return (
      <ProductInterface
          product = "windrose"
          ProductOptions = {WindroseOptions}
          processProduct = {processWindrose}
      />
  )
} 